<template>
  <div class="col-12 mb-3 lang-selector">
    <select
      v-model="activeLanguage"
      class="lang-selector__dropdown form-control mb-2"
    >
      <option v-for="lang in languages" :key="lang.code" :value="lang">
        {{ lang.code }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",

  computed: {
    activeLanguage: {
      get() {
        return this.$store.getters.activeLanguage;
      },

      set(lang) {
        this.$store.commit("SET_ACTIVE_LANGUAGE", lang);
      },
    },

    languages() {
      return this.$store.getters.langs;
    },
  },
};
</script>

<style lang="scss">
.lang-selector {
  pointer-events: none;
  position: sticky !important;
  top: 16px;
  z-index: 9001; // it's over 9000

  &__dropdown {
    box-shadow: 0 0px 2.2px rgba(0, 0, 0, 0.028),
      0 0px 5.3px rgba(0, 0, 0, 0.04), 0 0px 10px rgba(0, 0, 0, 0.05),
      0 0px 17.9px rgba(0, 0, 0, 0.06), 0 0px 33.4px rgba(0, 0, 0, 0.072),
      0 0px 80px rgba(0, 0, 0, 0.1) !important;
    margin-left: auto !important;
    pointer-events: auto;
    width: auto !important;

    &:focus {
      box-shadow: 0 0px 2.2px rgba(0, 0, 0, 0.028),
        0 0px 5.3px rgba(0, 0, 0, 0.04), 0 0px 10px rgba(0, 0, 0, 0.05),
        0 0px 17.9px rgba(0, 0, 0, 0.06), 0 0px 33.4px rgba(0, 0, 0, 0.072),
        0 0px 80px rgba(0, 0, 0, 0.1) !important;
    }
  }
}
</style>
